import * as React from "react";

import ModalContext from "src/components/shared/Modal/ModalContext";
import ModalContainer from "src/components/shared/Modal/ModalContainer";
import { ModalContextType } from "src/components/shared/Modal/ModalContext";

export interface ModalState {
  state?: "open" | "closed";
}

export type ModalContentType = React.ReactElement<ModalState>;

export interface ModalProps extends ModalState {
  content?: ModalContentType;
  /**
   * onBeforeClose handler
   *
   * return true to capture event and keep modal open
   */
  onBeforeClose?: () => boolean | void;
}

const ModalProvider: React.FunctionComponent = ({ children }) => {
  const [state, setState] = React.useState<ModalProps>({});


  const contextValue = React.useMemo<ModalContextType>(
    () => ({
      openFixedModal(content, onBeforeClose) {
        setState({
          content,
          onBeforeClose,
          state: "open",
        });
      },
      closeModal() {
        setState(prevState => ({
          ...prevState,
          state: "closed",
        }));
      },
      isOpen:state.state === "open"
    }),
    [state.state]
  );

  const handleClose = React.useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      if (event.target !== event.currentTarget) {
        return;
      }

      const shouldCancel = state.onBeforeClose?.();
      if (!shouldCancel) {
        contextValue.closeModal();
      }
    },
    [contextValue, state]
  );

  return (
    <ModalContext.Provider value={contextValue}>
      <ModalContainer state={state.state} onBackgroundClick={handleClose}>
        {state.content}
      </ModalContainer>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
